import React, { useState } from 'react';
import { ShieldCheck, Trophy, CalendarCheck, Info } from 'lucide-react';
import VenueManagerManagement from '../components/VenueManagerManagement';
import VenueOrganiserManagement from '../components/VenueOrganiserManagement';
import BookingStaffManagement from '../components/BookingStaffManagement';

const sections = [
  { id: 'managers', label: 'Venue managers', description: 'Venue operations & settings', icon: ShieldCheck, component: VenueManagerManagement },
  { id: 'organisers', label: 'Open Play organisers', description: 'Sessions & participants', icon: Trophy, component: VenueOrganiserManagement },
  { id: 'staff', label: 'Booking staff', description: 'Bookings & check-in', icon: CalendarCheck, component: BookingStaffManagement },
];

export default function UserManagement() {
  const [active, setActive] = useState('managers');
  const [visited, setVisited] = useState(['managers']);
  function select(id) {
    setActive(id);
    setVisited((current) => current.includes(id) ? current : [...current, id]);
  }
  return <div className="space-y-6">
    <header>
      <p className="text-xs font-semibold uppercase tracking-widest text-[#328B83]">Your venue team</p>
      <h1 className="mt-1 text-2xl font-bold text-[#163E4A]">Users & access</h1>
      <p className="mt-2 text-sm text-[#64748B]">Choose an access type to manage your team and their permissions.</p>
    </header>
    <nav aria-label="User access type" className="grid gap-2 rounded-2xl border border-[#DDE7EB] bg-white p-2 sm:grid-cols-3">
      {sections.map(({ id, label, description, icon: Icon }) => <button key={id} type="button" aria-pressed={active === id}
        aria-controls={'access-panel-' + id} onClick={() => select(id)}
        className={'flex items-center gap-3 rounded-xl px-4 py-3 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#328B83] ' +
          (active === id ? 'bg-[#EAF6F4] text-[#163E4A]' : 'text-[#64748B] hover:bg-[#F8FAFC]')}>
        <span className={'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ' + (active === id ? 'bg-[#264D59] text-white' : 'bg-[#F1F5F9] text-[#64748B]')}><Icon size={18}/></span>
        <span><span className="block text-sm font-semibold">{label}</span><span className="mt-0.5 block text-xs opacity-80">{description}</span></span>
      </button>)}
    </nav>
    {sections.map(({ id, label, component: Component }) => visited.includes(id) && <section key={id} id={'access-panel-' + id}
      aria-label={label} hidden={active !== id}>
      <Component />
    </section>)}
    <div className="flex items-start gap-3 rounded-xl bg-[#F1F5F9] px-4 py-3 text-xs leading-5 text-[#64748B]">
      <Info size={17} className="mt-0.5 shrink-0 text-[#264D59]"/>
      <p>Access is managed separately from a player’s FREAC account. Existing players keep their password, profile and booking history.</p>
    </div>
  </div>;
}
